import { Component, OnInit } from "@angular/core";
import { AcuerdosStoreService } from "./acuerdos.store";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-consultar-acuerdos",
  templateUrl: "./consultar-acuerdos.component.html",
  styleUrls: ["./consultar-acuerdos.component.scss"],
})
export class ConsultarAcuerdosComponent implements OnInit {
  familiesArray: any[] = [];
  locationsArray: any[] = [];
  articlesArrayChecks: any[] = [];

  locationsFilteredArray: any[] = [];
  familiesFilteredArray: any[] = [];
  articlesFilteredArray: any[] = [];

  searchQueryData: any = {
    fromDate: "2023-01-01",
    untilDate: "2024-01-01",
    articlesArray: ([] = []),
  };

  columns = [
    "PROVEEDOR",
    "FECHA",
    "PRODUCTO",
    "CANTIDAD",
    "COSTE",
    "ID_ALBARAN",
  ];

  constructor(private store: AcuerdosStoreService) {}

  async ngOnInit() {
    await this.getAllLocations();
  }

  async getAllLocations() {
    await this.store.getAllLocations();
    this.locationsFilteredArray = this.store.locations;
  }

  checkChecker(string: string, array: string[]) {
    for (const parameter of array) {
      const checkbox = document.getElementById(
        string + parameter
      ) as HTMLInputElement;
      console.log(checkbox);
      if (checkbox) {
        checkbox.checked = true;
        console.log("cambiado");
      } else {
        console.log("none");
      }
    }
  }

  arrayFilter(event, array) {
    const filterValue = (event.target as HTMLInputElement).value;
    console.log("value:" + filterValue);

    switch (array) {
      case "locations":
        var startTime = performance.now()
        this.locationsFilteredArray = this.store.locations.filter((match) =>
          match.nombre.toLowerCase().includes(filterValue.toLowerCase())
        );
        setTimeout(this.checkChecker, 1,"location", this.locationsArray);      
        break;
      case "families":
        this.familiesFilteredArray = this.store.families.filter((match) => match.Nombre.toLowerCase().includes(filterValue.toLowerCase()));
        setTimeout(this.checkChecker, 1,"family", this.familiesArray);             
        break;
      case "articles":
        this.articlesFilteredArray = this.store.articles.filter((match) =>
          match.Nombre.toLowerCase().includes(filterValue.toLowerCase())
        );
        setTimeout(this.checkChecker, 1,"article", this.articlesArrayChecks);
        break;
    }
}

  async getFamilies(locationId) {
    this.updateArray(locationId, "location");
    await this.getFamiliesFromLocation();
    this.familiesFilteredArray = this.store.families;
  }

  async getFamiliesFromLocation() {
    if (this.locationsArray.length != 0) {
      await this.store.getFamiliesFromLocations(this.locationsArray);
    } else {
      this.familiesArray = [];
      this.store.families = [];
      this.getArticlesFromFamily();
      this.articlesFilteredArray = this.store.articles;
    }
  }

  async getArticles(familyId) {
    this.updateArray(familyId, "families");
    await this.getArticlesFromFamily();
    this.articlesFilteredArray = this.store.articles;
  }

  async getArticlesFromFamily() {
    if (this.familiesArray.length != 0) {
      await this.store.getArticlesFromFamilies(this.familiesArray);
    } else {
      this.store.articles = [];
      this.articlesArrayChecks = [];
      this.searchQueryData.articlesArray = [];
    }
  }

  updateArray(item, array) {
    if (array === "location") {
      const index = this.locationsArray.indexOf(item);
      if (index === -1) {
        this.locationsArray.push(item);
      } else {
        this.locationsArray.splice(index, 1);
      }
    }
    if (array === "families") {
      const index = this.familiesArray.indexOf(item);
      if (index === -1) {
        this.familiesArray.push(item);
      } else {
        this.familiesArray.splice(index, 1);
      }
    }
    if (array === "article") {
      const index = this.searchQueryData.articlesArray.indexOf(
        "'" + item + "'"
      );
      if (index === -1) {
        this.searchQueryData.articlesArray.push("'" + item + "'");
        this.articlesArrayChecks.push(item);
      } else {
        this.searchQueryData.articlesArray.splice(index, 1);
      }
    }
  }

  send() {
    this.store.getBuysSearch(this.searchQueryData);
  }
}
